import React from 'react';

const About = () => {
  return (
    <section style={{ height: "100vh" }}>
      <h1>About Me!</h1>
    </section>
  );
};

export default About;
